import { gql } from '@apollo/client'

import { LOCATION_TYPE_NODE_FRAGMENT } from '../fragments'

const LOCATION_TYPE_QUERY = gql`
  query locationType($id: ID!) {
    locationType(id: $id) {
      id
      name
      description
      synonyms
      imageUrl
      iconUrl
      position
      maxPosition
      updatedAt
      isExcludedFromSearch
      isExcludedFromBrowsing
      updatedBy {
        id
        name
      }
      node {
        ...LocationTypeNodeFragment
      }
    }
  }
  ${LOCATION_TYPE_NODE_FRAGMENT}
`

export default LOCATION_TYPE_QUERY
